/**
 * Which list a drop goes to (user, 19/10/2026: "I want to know which lists
 * are being used"): the group's chip when the container runs several groups,
 * then the list's name — on every row.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { DayPlanContainerRow, DayPlanDropRow } from '../../../drop-generator.types';
import { GroupChip } from '../../shared/GroupChip';

export const ListCell: FC<{ container: DayPlanContainerRow; drop: DayPlanDropRow }> = ({ container, drop }) => {
  const group = container.groups.find((g) => g.listGroupId === drop.groupId);
  return (
    <span className="flex min-w-0 items-center gap-1.5">
      {container.groups.length > 1 && group ? <GroupChip name={group.groupName} color={group.groupColor} /> : null}
      {drop.listName ? (
        <span className="truncate font-mono text-xs font-medium" title={drop.listName}>
          {drop.listName}
        </span>
      ) : (
        <span className="text-xs text-muted-foreground">no list</span>
      )}
    </span>
  );
};
